import Route from '@ember/routing/route';
import type HotelSettingsCompetitorsBenchmarkCompsetBuilderRoute from 'lumen/routes/hotel/settings/competitors/benchmark/compset/builder';
import type { ModelFrom } from 'lumen/utils/routes';

export default class HotelSettingsCompetitorsBenchmarkCompsetBuilderDesiredCompsetRoute extends Route {
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  model() {
    const parentModel = this.modelFor(
      'hotel.settings.competitors.benchmark.compset.builder',
    ) as ModelFrom<HotelSettingsCompetitorsBenchmarkCompsetBuilderRoute>;

    const model = {
      compset: parentModel.compset,
      desiredCompset: parentModel.desiredCompset,
    };

    return model;
  }
}
